import { createContext } from "react";

const firmContext = createContext();

export default firmContext;